/* eslint-disable max-lines */
import { get_token, get_user_details } from "@/router";
import NotificationDropdown from '@/components/Notifications/Notification.vue'
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import CreatePortal from "@/components/CreatePortal/CreatePortal.vue";
import Loader from "@/components/Loader/LoaderView";
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";
import { append_active_organization_id } from "@/utils/organization_profile";


export default {
  props: {
    activeTab: String,
    portal_admin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NotificationDropdown,
    MenuSideBar,
    CreatePortal,
    Loader
  },

  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    isHomeFilterPage() {
      return this.$route.name === 'home_filter';
    },
    isAdverts() {
      return this.$route.name === 'adverts';
    },
    isPersonalProfile() {
      return this.$route.name === 'view_personal_profiles';
    },
    isPortalPage() {
      return this.$route.name === 'view_portal';
    },
    is_group_page() {
      return this.$route.name === 'view_group';
    },
    is_business_page() {
      return this.$route.name === 'view_business_profiles';
    },
    is_publish_portal() {
      return this.$route.name === 'publish_portal';
    },
    is_publish_report() {
      return this.$route.name === 'view_full_report';
    },
    // 1. Portals user is approved for
    your_portals() {
      return this.portals.filter(p =>
        p.name?.toLowerCase() !== 'default portal' &&
        !this.portal_is_public(p) &&
        p.has_access === 'approved'
      );
    },

    // 2. All discoverable portals not already in "your portals"
    other_portals() {
      return this.portals.filter(p => {
        const isDefault = p.name?.toLowerCase() === 'default portal';
        if (isDefault) return false;

        return this.portal_is_public(p) || (this.portal_is_discoverable(p) && p.has_access !== 'approved');
      });
    },
    displayed_your_portals() {
      return this.show_all_your_portals
        ? this.your_portals
        : this.your_portals.slice(0, this.your_portals_visible_count);
    },
    has_more_your_portals() {
      return this.your_portals.length > this.your_portals_visible_count;
    },
    active_mobile_nav_key() {
      const route_map = {
        home: 'feeds',
        home_filter: 'feeds',
        view_portal: 'portals',
        Marketplace: 'marketplace',
        marketplace: 'marketplace',
        incident_reporting: 'incident',
        view_events: 'events',
        view_group: 'groups',
        my_shop: 'menu',
        my_orders: 'menu',
        dashboard: 'menu',
      };

      return Reflect.get(route_map, this.$route.name) || '';
    },
    mobile_nav_keys() {
      return this.get_visible_mobile_nav_items().map(({ key }) => key);
    },
    show_group_member_mobile_nav() {
      return this.is_group_page;
    }
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetchPortals();

    if (client_domain.includes('tdm')) {
      this.tdm_domain = true;
    }
    if (client_domain.includes('workbook')) {
      this.workbook_domain = true;
    }
    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }
    if (client_domain.includes('dwypd') || client_domain.includes('nsp')) {
      this.soulcity = true;
    }
    if(client_domain.includes('chiefluthuli')) {
      this.school_domain = true;
    }
    if (client_domain.includes('demo') || client_domain.includes('engagenet')) {
      this.visible_domain = true;
    }
    if (client_domain.includes('engagenet') || client_domain.includes('apex') ) {
        this.incident = true;
      }
      if (client_domain.includes('engagenet') || client_domain.includes('vettedsa')){
        this.marketplace = true;
      }
  },
 inject: ['client_features'],

  data() {
    return ({
      token_exists: false,
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      workbook_domain: false,
      school_domain: false,
      visible_domain: false,
      portals: [],
      loading: true,
      selectedPortal: null,
      cbo_domain: false,
      soulcity: false,
      tdm_domain: false,
      request_access:false,
      incident:false,
      marketplace:false,
      show_all_your_portals: false,
      your_portals_visible_count: 5
    });
  },
  methods: {
    createPortal() {
      this.fetchPortals();
    },
    getToken() {
      return get_token();
    },
    getInitials(name) {
        const words = name.trim().split(" ");
        return words.length === 1
          ? words[0].substring(0, 2).toUpperCase()
          : (words[0][0] + words[1][0]).toUpperCase();
      },
    is_admin_user() {
      return this.user_details.user_role === 'admin'
        || this.user_details.user_role === 'organization admin'
        || this.portal_admin;
    },
    get_visible_mobile_nav_items() {
      return this.get_mobile_nav_items().filter(({ is_visible }) => is_visible());
    },
    get_mobile_nav_items() {
      return [
        { key: 'portals', is_visible: this.show_portals_mobile_nav },
        { key: 'boards', is_visible: this.show_boards_mobile_nav },
        { key: 'feeds', is_visible: this.show_feeds_mobile_nav },
        { key: 'segments', is_visible: this.show_segments_mobile_nav },
        { key: 'marketplace', is_visible: this.show_marketplace_mobile_nav },
        { key: 'incident', is_visible: this.show_incident_mobile_nav },
        { key: 'events', is_visible: this.show_events_mobile_nav },
        { key: 'groups', is_visible: this.show_groups_mobile_nav },
        { key: 'alerts', is_visible: this.show_alerts_mobile_nav },
        { key: 'group_member', is_visible: this.show_group_member_mobile_nav_item },
        { key: 'menu', is_visible: this.show_menu_mobile_nav },
      ];
    },
    all_mobile_nav_conditions(conditions) {
      return conditions.every(Boolean);
    },
    show_portals_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_portals, !this.is_group_page, this.token_exists]);
    },
    show_boards_mobile_nav() {
      return this.all_mobile_nav_conditions([!this.isHomePage, !this.is_group_page, !this.isHomeFilterPage, this.isPortalPage, this.token_exists]);
    },
    show_feeds_mobile_nav() {
      return true;
    },
    show_segments_mobile_nav() {
      return this.show_boards_mobile_nav();
    },
    show_marketplace_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_marketplace, !this.isPortalPage, !this.is_business_page, !this.is_group_page]);
    },
    show_incident_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_incident, !this.isPortalPage, !this.is_business_page, !this.is_group_page]);
    },
    show_events_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_events, !this.is_group_page, !this.isHomeFilterPage, !this.isPortalPage]);
    },
    show_groups_mobile_nav() {
      return this.is_group_page || this.all_mobile_nav_conditions([!this.isHomePage, this.token_exists, this.isPortalPage]);
    },
    show_alerts_mobile_nav() {
      return this.token_exists;
    },
    show_group_member_mobile_nav_item() {
      return this.show_group_member_mobile_nav;
    },
    show_menu_mobile_nav() {
      return this.all_mobile_nav_conditions([!this.is_group_page, !this.isPortalPage, this.token_exists]);
    },
    is_mobile_nav_active(key) {
      return this.active_mobile_nav_key === key;
    },
    get_mobile_nav_item_style(key) {
      return ({ order: this.get_mobile_nav_item_order(key) });
    },
    get_mobile_nav_item_order(key) {
      const nav_keys = this.mobile_nav_keys;
      const active_index = nav_keys.indexOf(this.active_mobile_nav_key);
      const item_index = nav_keys.indexOf(key);

      if (item_index < 0 || active_index < 0) {
        return item_index;
      }

      return this.get_centered_mobile_nav_order(item_index, active_index);
    },
    get_centered_mobile_nav_order(item_index, active_index) {
      const center_index = Math.floor((this.mobile_nav_keys.length - 1) / 2);

      if (item_index === active_index) {
        return center_index;
      }

      const adjusted_index = item_index < active_index ? item_index : item_index - 1;
      return adjusted_index >= center_index ? adjusted_index + 1 : adjusted_index;
    },
    portal_is_public(portal) {
      return String(portal?.is_public).toLowerCase() === 'true';
    },
    portal_visibility_enabled(portal) {
      return String(portal?.is_visible).toLowerCase() === 'true';
    },
    portal_user_has_access(portal) {
      return portal?.has_access === 'approved';
    },
    portal_is_discoverable(portal) {
      if (this.portal_is_public(portal)) {
        return true;
      }

      if (this.is_admin_user()) {
        return true;
      }

      if (this.portal_user_has_access(portal)) {
        return true;
      }

      return this.portal_visibility_enabled(portal);
    },
    portal_can_request_access(portal) {
      return (
        !this.portal_is_public(portal) &&
        this.portal_visibility_enabled(portal) &&
        portal?.has_access !== 'approved' &&
        portal?.has_access !== 'pending'
      );
    },
    toggle_your_portals() {
      this.show_all_your_portals = !this.show_all_your_portals;
    },
    fetchPortals() {
      this.token_exists = this.getToken();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
        method: 'POST',
        headers: this.token_exists
          ? {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          }
          : {},
        data: JSON.stringify(append_active_organization_id(this.payload)),
        success: (data) => {
          if (data.portals) {
            this.portals = data.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );
          } else {
            this.portals = [];
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handle_unauthenticated() {
      if (!this.token_exists) {
        this.$router.push({ name: 'sign_in_finale' });
        return false;
      }
      return true;
    },
    open_portal(portal_id, portal_name, is_public, portal_type, is_visible) {

      if (portal_type?.name === 'incident') {
        this.$router.push({ name: 'view_incidents', params: { portal_id: portal_id, portal_name: portal_name, } });
      }
      else if (portal_type?.name === 'publishing') {

        this.$router.push({ name: 'publish_portal', params: { portal_id: portal_id, portal_name: portal_name, } });
      }
      else {

        this.$router.push({ name: 'view_portal', params: { portal_id: portal_id, portal_name: portal_name, is_public: is_public, is_visible: is_visible } });
        this.filterReports(portal_id);
      }
    },
    filterReports(portal_id) {
      this.loading = true;
      const payload = {
        filter_values: {
          portal_id: portal_id
        }
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.$emit('portal_selected', response.data.report_data);
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);

        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handlePortalClick(portal) {
      if (!this.handle_unauthenticated()) {
        return;
      }
      this.is_public = portal.is_public


      if (portal.has_access == "approved") {
        this.$emit('portal_profile', portal);
        this.open_portal(portal.id, portal.name, portal.is_public, portal.portal_type, portal.is_visible);

        // this.get_portal_access_requested_users();
        $("#request_access").modal('hide');
      }

      else if (portal.has_access == "pending") {
        $("#request_access").modal('hide');
        Swal.fire({
          icon: 'info',
          title: 'Info',
          text: 'Access request already submitted.',
          showConfirmButton: false,
          timer: 3000,
          position: 'bottom-end',
          toast: true
        })
        return;
      }

      else {
        $("#request_access").modal('show');
        this.selectedPortal = portal;
        return;
      }

    },

    requestAccess() {
      const PORTAL_ID = this.selectedPortal ? this.selectedPortal.id : null;

      this.request_access = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/request_access_private_portal/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          portal_id: PORTAL_ID,
        }),
        success: (data) => {
          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Access request submitted successfully.',
              showConfirmButton: false,
              timer: 3600,
              position: 'bottom-end',
              toast: true
            })
          }
          else {
            Swal.fire({
              icon: 'info',
              title: 'Info',
              text: 'Request Already Sent',
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            })
          }
        },
        complete: () => {
          this.isLoading = false;
          this.selectedPortal = null;
          this.request_access = false;
          $("#request_access").modal('hide');
        }
      });
    },
  }
}
